export const DEFAULT_PAGE_SIZES = [2, 10, 25, 50, 100]

export function dataTablePaginationToOffsetAndLimit({page, rowsPerPage}) {
  return {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage
  }
}



// WEBPACK FOOTER //
// ./src/helpers/pagination.js